import axios from "axios";
import { LoginWithPinRequest } from "../../Models/Request/Authentication/Login";
import {
  DeleteUserOtp,
  SendOtpRequest,
  VerifyOtpRequest,
} from "../../Models/Request/Authentication/Otp";
import {
  SignupConfirmationRequest,
  SignupOtpInitiateRequest,
} from "../../Models/Request/Authentication/Signup";

export function sendOtp(sendOtpBody: SendOtpRequest) {
  return axios.post("/public/user/send-otp", sendOtpBody);
}

export function verifyOtp(verifyOtpBody: VerifyOtpRequest) {
  return axios.post("/public/user/verify-otp", verifyOtpBody);
}

export function signupOtp(signupOtpBody: SignupOtpInitiateRequest) {
  return axios.post("/public/user/signup", signupOtpBody);
}

export function signupVerification(
  verificationBody: SignupConfirmationRequest
) {
  return axios.post("/public/user/signup/verify", verificationBody);
}

export function logInWithPin(verificationBody: LoginWithPinRequest) {
  return axios.post("/public/user/login", verificationBody);
}

export function getAccessToken(refreshToken: string | null) {
  return axios.post(`/public/user/refreshtoken`, {
    refresh_token: refreshToken,
  });
}

export function forgotPin(newPin: string, token: string) {
  return axios.post(
    `/User/forgotPassword`,
    { newPin },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function signOut() {
  return axios.get(`/User/sign-out`);
}

export function deleteUserInitiate() {
  return axios.delete(`/User`);
}

export function deleteUser(body: DeleteUserOtp) {
  return axios.delete(`/User/Verify`, { data: body });
}
